<template>
  <tr class="row-data">
    <td class="day-data" :class="{ weekend: isWeekend, today: is_today }">
      <div class="cell">
        <div class="d-flex justify-space-between">
          <span class="text-uppercase font-weight-bold" v-html="day_of_week">
          </span>
          <v-tooltip v-if="is_today" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="secondary"
                size="14"
                class="ml-1"
              >
                mdi-calendar-today
              </v-icon>
            </template>
            <span class="text-uppercase">{{ $t("today") }}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <a-rms-strategy-day-comments
            v-if="comments.length > 0"
            :date="date"
            :comments="comments"
          />
          <!-- Events placeholder if data is available -->
          <div
            v-if="events && events.length > 0"
            class="d-flex"
            style="margin-top: 2px;"
          >
            <a-rms-strategy-day-events
              v-for="impact in impacts"
              :key="impact.impact"
              :impact="impact"
              :events="events"
              :date="date"
            />
          </div>
        </div>
      </div>
    </td>
    <td
      v-for="column in columns"
      :key="column.room_rate_id"
      class="clickable-cell"
      :class="{
        'cell-selected': isCellSelected(column.room_rate_id),
        'cell-in-range': isCellInRange(column.room_rate_id),
        weekend: isWeekend
      }"
      @click="handleCellClick($event, column)"
      @mouseover="handleMouseOver($event, column.room_rate_id)"
      @mouseleave="$emit('cell-hover', null)"
    >
      <div class="cell">
        <!-- <v-row>
          <v-col cols="12" md="7" class="py-0 align-center">
            <div
              v-if="getRoomRateData(column.room_rate_id)"
              class="d-flex align-center justify-end"
              style="gap: 10px;"
            >
              <v-tooltip
                bottom
                v-if="isCircularReference(getRoomRateData(column.room_rate_id))"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="error"
                    small
                    class="ml-1"
                  >
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>
                  {{
                    $t("circular_reference_error", {
                      name: getRoomRateData(column.room_rate_id)
                        .ref_room_rate_name
                    })
                  }}
                </span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <template v-if="columns.length >= 10">
                    <span v-bind="attrs" v-on="on" class="text-uppercase">
                      {{
                        getRoomTypeById(
                          getRoomRateData(column.room_rate_id).ref_room_rate_id
                        ).code
                      }}
                    </span>
                  </template>
                  <template v-else>
                    <span v-bind="attrs" v-on="on">
                      {{
                        getRoomTypeById(
                          getRoomRateData(column.room_rate_id).ref_room_rate_id
                        ).name
                      }}
                    </span>
                  </template>
                </template>
                <span
                  :class="{
                    'red--text font-weight-bold': isCircularReference(
                      getRoomRateData(column.room_rate_id)
                    )
                  }"
                >
                  {{ getRoomRateData(column.room_rate_id).ref_room_rate_name }}
                </span>
              </v-tooltip>
              <a-increment
                :kpi="
                  getRoomRateData(column.room_rate_id).ref_operation ===
                  'absolute'
                    ? 'price'
                    : 'market_demand'
                "
                :value="getFakeValue(getRoomRateData(column.room_rate_id))"
                :vs_value="100"
                :absolute="
                  getRoomRateData(column.room_rate_id).ref_operation ===
                    'absolute'
                "
                hide_icon
                hide_tooltip
                show_plus_sign
                percent_format="percent0"
                iconRight
              />
            </div>
            <div v-else class="grey--text text-truncate text-right">
              {{ $t("base_rate") }}
            </div>
          </v-col>
          <v-col cols="12" md="5" class="py-0 align-center">
            <v-tooltip
              bottom
              v-if="
                getRoomRateDataFull(column.room_rate_id) &&
                  getRoomRateDataFull(column.room_rate_id).available_rooms !=
                    null
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  v-bind="attrs"
                  v-on="on"
                  color="secondary lighten-4"
                  size="16"
                >
                  <span class="font-weight-bold" style="font-size:9px;">
                    {{
                      getRoomRateDataFull(column.room_rate_id).available_rooms
                    }}
                  </span>
                </v-avatar>
              </template>
              <span>
                {{
                  getRoomRateDataFull(column.room_rate_id).available_rooms +
                    " " +
                    $t("available_rooms")
                }}
              </span>
            </v-tooltip>
          </v-col>
        </v-row> -->
        <div
          class="d-flex align-center justify-space-between"
          :style="{ gap: columns.length >= 10 ? '5px' : '10px' }"
        >
          <div :style="{ flexBasis: columns.length >= 10 ? '70%' : '60%' }">
            <div
              v-if="getRoomRateData(column.room_rate_id)"
              class="d-flex align-center w-100"
              :class="{
                'justify-space-between': columns.length >= 10,
                'justify-end': columns.length < 10
              }"
              style="gap: 10px;"
            >
              <v-tooltip
                bottom
                v-if="isCircularReference(getRoomRateData(column.room_rate_id))"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="error"
                    small
                    class="ml-1"
                  >
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>
                  {{
                    $t("circular_reference_error", {
                      name: getRoomRateData(column.room_rate_id)
                        .ref_room_rate_name
                    })
                  }}
                </span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <template v-if="columns.length >= 10">
                    <span v-bind="attrs" v-on="on" class="text-uppercase">
                      {{
                        getRoomTypeById(
                          getRoomRateData(column.room_rate_id).ref_room_rate_id
                        ).code
                      }}
                    </span>
                  </template>
                  <template v-else>
                    <span v-bind="attrs" v-on="on">
                      {{
                        getRoomTypeById(
                          getRoomRateData(column.room_rate_id).ref_room_rate_id
                        ).name
                      }}
                    </span>
                  </template>
                </template>
                <div
                  :class="{
                    'red--text font-weight-bold': isCircularReference(
                      getRoomRateData(column.room_rate_id)
                    )
                  }"
                >
                  {{ ruleExplanation(getRoomRateData(column.room_rate_id)) }}
                </div>
                <div class="caption">
                  {{ $t("ref_rule_explanation_hint") }}
                </div>
              </v-tooltip>
              <a-increment
                :kpi="
                  getRoomRateData(column.room_rate_id).ref_operation ===
                  'absolute'
                    ? 'price'
                    : 'market_demand'
                "
                :value="getFakeValue(getRoomRateData(column.room_rate_id))"
                :vs_value="100"
                :absolute="
                  getRoomRateData(column.room_rate_id).ref_operation ===
                    'absolute'
                "
                hide_icon
                hide_tooltip
                show_plus_sign
                percent_format="percent0"
                iconRight
              />
            </div>
            <div v-else class="grey--text text-truncate text-right">
              {{ $t("base_rate") }}
            </div>
          </div>
          <div
            class="d-flex align-center"
            :class="{
              'justify-end': columns.length >= 10,
              'justify-start': columns.length < 10
            }"
            :style="{ flexBasis: columns.length >= 10 ? '30%' : '40%' }"
          >
            <v-tooltip
              bottom
              v-if="
                getRoomRateDataFull(column.room_rate_id) &&
                  getRoomRateDataFull(column.room_rate_id).available_rooms !=
                    null
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  v-bind="attrs"
                  v-on="on"
                  color="secondary lighten-4"
                  size="16"
                >
                  <span class="font-weight-bold" style="font-size:9px;">
                    {{
                      getRoomRateDataFull(column.room_rate_id).available_rooms
                    }}
                  </span>
                </v-avatar>
              </template>
              <span>
                {{
                  getRoomRateDataFull(column.room_rate_id).available_rooms +
                    " " +
                    $t("available_rooms")
                }}
              </span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import aRmsStrategyDayComments from "@/components/rms/aRmsStrategyDayComments";
import aRmsStrategyDayEvents from "@/components/rms/aRmsStrategyDayEvents";
import aIncrement from "@/components/rms_ui/aIncrement.vue";
import * as Utils from "@/utils.js";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "a-ref-prices-table-row",
  components: {
    aIncrement,
    aRmsStrategyDayEvents,
    aRmsStrategyDayComments
  },
  props: {
    row: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    selection: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    date() {
      return this.row.date;
    },
    formattedDate() {
      return Vue.moment(this.date).format("DD MMM");
    },
    day_of_week() {
      return Utils.getFriendlyDayStrategy(this.date, true);
    },
    isWeekend() {
      return Vue.moment(this.date).isoWeekday() > 5;
    },
    is_today() {
      return this.date === Vue.moment().format("YYYY-MM-DD");
    },
    comments() {
      if (!this.calendar_store || !this.calendar_store.hotel_comments)
        return [];
      return this.calendar_store.hotel_comments.filter(
        c => c.date === this.date
      );
    },
    impacts() {
      if (!this.calendar_store || !this.calendar_store.impacts) return [];

      let events_count = this.calendar_store.impacts.map(i => {
        return {
          impact: i.value,
          color: i.color,
          count: this.events.filter(e => e.impact === i.value).length
        };
      });
      return events_count.filter(e => e.count > 0);
    },
    ...mapState({
      calendar_store: state => state.calendar
    }),
    ...mapGetters({
      getRoomTypeById: "getRoomTypeById",
      l: "current_hotel_language"
    })
  },
  methods: {
    isCircularReference(roomRateData) {
      if (!roomRateData || !roomRateData.ref_room_rate_id) return false;

      const visited = new Set([roomRateData.room_rate_id]);
      let currentRefId = roomRateData.ref_room_rate_id;

      // Let's trace it within the row data available
      while (currentRefId) {
        if (currentRefId === roomRateData.room_rate_id) {
          return true;
        }
        if (visited.has(currentRefId)) {
          return false; // Cycle elsewhere, not involving us directly as the start
        }
        visited.add(currentRefId);

        // Find the next link in the chain within this same row (same date)
        const nextRoomRate = this.row.room_rates.find(
          rr => rr.room_rate_id === currentRefId
        );
        if (!nextRoomRate || !nextRoomRate.ref_room_rate_id) {
          break;
        }
        currentRefId = nextRoomRate.ref_room_rate_id;
      }

      return false;
    },
    getRoomRateData(roomRateId) {
      if (!this.row.room_rates) return null;
      const roomRate = this.row.room_rates.find(
        rr => rr.room_rate_id === roomRateId
      );
      if (!roomRate || !roomRate.ref_room_rate_id) {
        return null;
      }
      return roomRate;
    },
    getRoomRateDataFull(roomRateId) {
      if (!this.row.room_rates) return null;
      return this.row.room_rates.find(rr => rr.room_rate_id === roomRateId);
    },
    // "City Smart (1 pax) = Deluxe (2 pax) -10 €": the rule links the base
    // occupancies of both categories, which can be different.
    ruleExplanation(roomRateData) {
      const child = this.getRoomTypeById(roomRateData.room_rate_id) || {};
      const ref = this.getRoomTypeById(roomRateData.ref_room_rate_id) || {};
      const value = Number(roomRateData.ref_value) || 0;
      const sign = value > 0 ? "+" : value < 0 ? "−" : "";
      const unit =
        roomRateData.ref_operation === "percent"
          ? "%"
          : " " + ((this.l && this.l.money_post_symbol) || "€").trim();
      return this.$t("ref_rule_explanation", {
        child: child.name || roomRateData.room_rate_name || "",
        child_pax: child.pax_base || "-",
        ref: ref.name || roomRateData.ref_room_rate_name || "",
        ref_pax: ref.pax_base || "-",
        value: sign + Math.abs(value) + unit
      });
    },
    getFakeValue(roomRateData) {
      const refValue = roomRateData.ref_value || 0;
      if (roomRateData.ref_operation === "percent") {
        return 100 + refValue;
      } else {
        return 100 + refValue;
      }
    },
    isCellSelected(roomRateId) {
      if (!this.selection.start_date) return false;
      // Check if this cell is the start of the selection
      if (
        this.selection.start_date === this.date &&
        this.selection.room_rate_ids &&
        this.selection.room_rate_ids.includes(roomRateId)
      ) {
        return true;
      }
      return false;
    },
    isCellInRange(roomRateId) {
      if (
        !this.selection.start_date ||
        !this.selection.room_rate_ids ||
        this.selection.room_rate_ids.length === 0
      ) {
        return false;
      }
      // Check if this room_rate_id is in the selection
      if (!this.selection.room_rate_ids.includes(roomRateId)) {
        return false;
      }
      // Check date range (use hover_date if no end_date yet)
      const endDate = this.selection.end_date || this.selection.hover_date;
      if (!endDate) {
        return this.date === this.selection.start_date;
      }
      const sortedDates = [this.selection.start_date, endDate].sort();
      return this.date >= sortedDates[0] && this.date <= sortedDates[1];
    },
    handleCellClick(event, column) {
      // Prevent text selection when using Shift+Click
      if (event.shiftKey) {
        event.preventDefault();
        window.getSelection().removeAllRanges();
      }
      this.$emit("cell-click", {
        date: this.date,
        room_rate_id: column.room_rate_id,
        shiftKey: event.shiftKey
      });
    },
    handleMouseOver(event, roomRateId) {
      this.$emit("cell-hover", roomRateId);
      // If we have a selection started (but not completed), emit hover date for preview
      if (this.selection.start_date && !this.selection.end_date) {
        this.$emit("cell-hover-date", this.date);
      }
    }
  }
};
</script>

<style scoped lang="scss">
tr {
  &:hover {
    td:first-child {
      box-shadow: inset -2px 0 0 0 #2d6ece, 2px 0 5px rgba(0, 0, 0, 0.05);
    }
  }
  td {
    border: none;
    background-color: white;
    border-right: 1px solid #eee; // Lighter border than RMS for cleaner look
    border-bottom: 1px solid #eee;
    padding: 4px 7px;
    &:first-child {
      position: sticky;
      left: 0;
      z-index: 2;
      background: white;
      border-right: 2px solid #ddd; // Separation for sticky column
      box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    }
    &.weekend {
      background-color: #fffef4;
    }
    &.today {
      background-color: #e3f2fd;
      &:first-child {
        background-color: #e3f2fd; // Ensure sticky column also gets color
      }
    }
    .cell {
      font-size: 12px;
      white-space: nowrap;
      min-width: 100%;
    }
    &.clickable-cell {
      cursor: pointer;
      transition: background-color 0.1s;
      user-select: none;
      -webkit-user-select: none;
      &:hover {
        background-color: rgba(0, 132, 200, 0.1);
      }
      &.cell-selected {
        background-color: rgba(0, 132, 200, 0.3) !important;
        position: relative;
        z-index: 1; // Show above borders
        outline: 2px solid #1576c7;
        outline-offset: -2px;
      }
      &.cell-in-range {
        background-color: rgba(0, 132, 200, 0.15) !important;
      }
    }
  }
}
</style>
